/* eslint-disable */
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import useMatStyles from "./style";
import NewAdminUser from "./modals/NewAdminUser";
import ChangeRole from "./modals/ChangeRole";
import { hideLoader, showLoader } from "../../utils/loader";
import Layout from "../../components/Layout";

import { Tabs, DatePicker, Select as AntSelect } from "antd";
const { TabPane } = Tabs;
import { SettingFilled } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import UpdateKYC from "./modals/udateKYC";
import {
  customBaseUrl,
  httpDelete,
  httpGet,
  httpPost,
  httpPut,
  httpPostBlob,
} from "../../store/http";
import ExportData from "./export";

//KELVINSEKX
import { Box, Stack, Button, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AntTable from "../../components/CustomTable/AntTable";
import { TableResultCount } from "../../components/shared/table-result-count";
import { PageHeader } from "../../components/shared/page-header";
import {
  SearchTypeSelector,
  DecorateListTypes,
} from "../../components/shared/search-filter-bar";
import { PrimaryCreateButton } from "../../components/shared/primary-create-button";
import { AdminColumns } from "./shared/components/admins.column";
import { PendingAdminColumns } from "./shared/components/pending-admins-columns";
import { DeletedAdminColumns } from "./shared/components/deleted-admins-columns";
import ReactivateAdmin from "./modals/ReactivateAdmin";

const searchTypes = [
  { value: "firstName", label: "First Name", placeholder: "Enter first name" },
  { value: "email", label: "Email", placeholder: "Enter email" },
];

const userStatuses = [
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Inactive" },
  { value: "SUSPENDED", label: "Suspended" },
  { value: "CLOSED", label: "Closed" },
];

const kycStatuses = [
  { value: "VERIFIED", label: "Verified" },
  { value: "PENDING", label: "Pending" },
  { value: "REJECTED", label: "Rejected" },
  { value: "UNVERIFIED", label: "Unverified" },
];

export default function Index() {
  const styles = useMatStyles();
  const navigate = useNavigate();
  const [showAdmin, setShowAdmin] = useState(false);
  const [showChangeRole, setShowChangeRole] = useState({ isVisible: false });
  const [showUpdateKYC, setShowUpdateKYC] = useState({ isVisible: false });
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [data, setData] = useState([]);
  const [metaData, setMetaData] = useState(0);
  const [links, setLinks] = useState({});
  const [selectedUser, setSelectedUser] = useState("");
  const [units, setUnits] = useState([]);

  const [search, setSearch] = useState({
    searchBy: "firstName",
    searchText: "",
  });
  const [dateRange, setDateRange] = useState(null);
  const [status, setStatus] = useState(null);
  const [kycStatus, setKycStatus] = useState(null);
  const [showExport, setShowExport] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 100 });

  const [pendingRequests, setPendingRequests] = useState([]);
  const [pendingMetaData, setPendingMetaData] = useState(0);
  const [pendingPagination, setPendingPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const [deletedUsers, setDeletedUsers] = useState([]);
  const [deletedMetaData, setDeletedMetaData] = useState(0);
  const [deletedPagination, setDeletedPagination] = useState({
    current: 1,
    pageSize: 20,
  });
  const [deletedLoading, setDeletedLoading] = useState(false);
  const [reactivateTarget, setReactivateTarget] = useState(null);
  const [reactivateSubmitting, setReactivateSubmitting] = useState(false);

  const [activeTab, setActiveTab] = useState("1");

  //KELVINSEKX
  const [loading, setLoading] = useState(false);
  const [pendingLoading, setPendingLoading] = useState(false);
  const currentType = searchTypes.find((t) => t.value === search.searchBy);
  const placeholder = currentType?.placeholder || "Enter search query";

  const handleActivation = async (userId, isActive) => {
    const { value: reason } = await Swal.fire({
      title: `Enter reason for ${isActive ? "activation" : "deactivation"}`,
      input: "text",
      inputLabel: "Reason",
      inputPlaceholder: "Enter your reason here...",
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "You need to provide a reason!";
        }
      },
    });

    if (reason) {
      showLoader();
      const response = await httpPut(
        `${customBaseUrl.authUrl}/admin/users/${userId}/active?isActive=${isActive}&reason=${reason}`,
        {},
      );
      hideLoader();
      if (response.success === true || response.status === true) {
        Swal.fire(
          "Success",
          response.message || "Operation successful",
          "success",
        );
        getAdminUsers();
      } else {
        Swal.fire(
          "Error",
          response.error?.message || response.message || "An error occurred",
          "error",
        );
      }
    }
  };

  const deleteAdminUser = async (userId) => {
    showLoader();
    const response = await httpDelete(
      `${customBaseUrl.authUrl}/api/v1/admin/users/${userId}`,
    );
    hideLoader();
    if (response.success === true) {
      Swal.fire("Deleted!", "The admin user has been deleted.", "success");
      getAdminUsers();
    } else {
      Swal.fire(
        "Error",
        response.error?.message || response.message || "An error occurred",
        "error",
      );
    }
  };

  const sekxhandleDropdownAction = (item, row) => {
    setSelectedUser(row);
    if (item === "Change Role") {
      handleShowChangeRole(row);
    } else if (item === "Activity Log") {
      navigate(`/user/activity_log/${row.id}`);
    } else if (item === "View Details") {
      navigate(`/users/admin-details/${row.id}`, {
        state: users.find((user) => user.id === row.id),
      });
    } else if (item === "Activate") {
      handleActivation(row.id, true);
    } else if (item === "Deactivate") {
      handleActivation(row.id, false);
    } else if (item === "Delete") {
      Swal.fire({
        title: "Are you sure you want to delete this user?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          deleteAdminUser(row.id);
        }
      });
    }
  };

  const handleChangePage = async ({ pagination: info }) => {
    setPagination(info);
    await getAdminUsers(info.current - 1, info.pageSize);
  };

  const getAdminUsers = async (page, size) => {
    setLoading(true);
    showLoader();
    const pages = page !== undefined ? page : 0;
    const limit = size ? size : pagination.pageSize;
    const payload = {
      userType: "ADMIN",
      page: pages,
      size: limit,
    };
    if (dateRange) {
      payload.createdDateFrom = dateRange[0].format('YYYY-MM-DDT00:00:00');
      payload.createdDateTo = dateRange[1].format('YYYY-MM-DDT23:59:59');
    }
    if (status) {
      payload.status = status;
    }
    if (kycStatus) {
      payload.kycStatus = kycStatus;
    }
    const response = await httpPost(
      `${customBaseUrl.authUrl}/admin/users/search?`,
      payload,
    );
    if (response?.success) {
      hideLoader();

      const data = response?.data;
      setUsers(data?.users);
      setMetaData(data?.totalElements);
      setLinks(data?._links);
    } else if (response?.success === false) {
      hideLoader();
    } else {
      hideLoader();
    }
    setLoading(false);
  };

  const getPendingCreations = async (page, size) => {
    showLoader();
    const pages = page ? page : page === 0 ? 0 : pendingPagination.current;
    const limit = size ? size : pendingPagination.pageSize;
    try {
      const response = await httpGet(
        `${customBaseUrl.authUrl}/api/v1/admin-creations?page=${pages}&size=${limit}`,
      );
      hideLoader();
      if (response?.success) {
        setPendingRequests(response.data);
        setPendingMetaData(response.data.length ?? 0);
      }
    } catch (error) {
      hideLoader();
      console.error("Error fetching pending creations:", error);
    }
  };

  const getDeletedAdmins = async (page, size) => {
    setDeletedLoading(true);
    showLoader();
    const pages = page !== undefined ? page : 0;
    const limit = size ? size : deletedPagination.pageSize;
    try {
      const response = await httpGet(
        `${customBaseUrl.authUrl}/api/v1/admin/users/deleted?page=${pages}&size=${limit}`,
      );
      hideLoader();
      if (response?.success || response?.status) {
        const data = response?.data;
        const list = data?.items || [];
        setDeletedUsers(list);
        setDeletedMetaData(data?.totalElements ?? list.length ?? 0);
      }
    } catch (error) {
      hideLoader();
      console.error("Error fetching deleted admins:", error);
    } finally {
      setDeletedLoading(false);
    }
  };

  const handleReactivateAdmin = async ({ roles, permissions, newPassword }) => {
    if (!reactivateTarget) return;
    const userId = reactivateTarget.id || reactivateTarget.userId;
    setReactivateSubmitting(true);
    showLoader();
    try {
      const response = await httpPost(
        `${customBaseUrl.authUrl}/api/v1/admin/users/${userId}/reactivate`,
        { roles, permissions, newPassword },
      );
      hideLoader();
      if (response?.success || response?.status) {
        Swal.fire(
          "Reactivated",
          response.message || "Admin user has been reactivated.",
          "success",
        );
        setReactivateTarget(null);
        getDeletedAdmins(
          deletedPagination.current - 1,
          deletedPagination.pageSize,
        );
        getAdminUsers();
      } else {
        Swal.fire(
          "Error",
          response?.error?.message ||
            response?.message ||
            "Failed to reactivate user",
          "error",
        );
      }
    } catch (error) {
      hideLoader();
      Swal.fire("Error", "An error occurred during reactivation", "error");
    } finally {
      setReactivateSubmitting(false);
    }
  };

  const handleApproveRequest = async (id) => {
    const { value: remarks } = await Swal.fire({
      title: "Approve Request",
      input: "text",
      inputLabel: "Checker Remarks",
      inputPlaceholder: "Enter remarks...",
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "You need to provide remarks!";
        }
      },
    });

    if (remarks) {
      showLoader();
      try {
        const response = await httpPost(
          `${customBaseUrl.authUrl}/api/v1/admin-creations/${id}/approve?checkerRemarks=${remarks}`,
          {},
        );
        hideLoader();
        if (response.success || response.status) {
          Swal.fire("Approved", "Request successfully approved", "success");
          getPendingCreations();
          getAdminUsers();
        } else {
          Swal.fire(
            "Error",
            response.message || "Failed to approve request",
            "error",
          );
        }
      } catch (error) {
        hideLoader();
        Swal.fire("Error", "An error occurred during approval", "error");
      }
    }
  };

  const handleRejectRequest = async (id) => {
    const { value: remarks } = await Swal.fire({
      title: "Reject Request",
      input: "text",
      inputLabel: "Checker Remarks",
      inputPlaceholder: "Enter remarks...",
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "You need to provide remarks!";
        }
      },
    });

    if (remarks) {
      showLoader();
      try {
        const response = await httpPost(
          `${customBaseUrl.authUrl}/api/v1/admin-creations/${id}/reject?checkerRemarks=${remarks}`,
          {},
        );
        hideLoader();
        if (response.success || response.status) {
          Swal.fire("Rejected", "Request successfully rejected", "success");
          getPendingCreations();
        } else {
          Swal.fire(
            "Error",
            response.message || "Failed to reject request",
            "error",
          );
        }
      } catch (error) {
        hideLoader();
        Swal.fire("Error", "An error occurred during rejection", "error");
      }
    }
  };

  const getRoles = async () => {
    const response = await httpGet(
      `${customBaseUrl.authUrl}/api/v1/admin/users/roles`,
    );
    if (Array.isArray(response)) {
      setRoles(response);
    } else if (response.data && Array.isArray(response.data)) {
      setRoles(response.data);
    } else if (response.data && response.data.success) {
      setRoles(response.data.data);
    } else if (response.success) {
      setRoles(response.data);
    }
  };

  const getPermissions = async () => {
    const response = await httpGet(
      `${customBaseUrl.authUrl}/api/v1/admin/users/permissions`,
    );
    if (response.data && response.data.success) {
      setPermissions(response.data.data);
    } else if (response.success) {
      setPermissions(response.data);
    } else {
      console.error("Unexpected permissions response structure:", response);
    }
  };

  const getUnits = async () => {
    const response = await httpGet(
      `${customBaseUrl.roleUrl}/api/v1/menu/fetchAll`,
    );
    hideLoader();
    if (!response || response.error !== undefined) {
      return;
    }
    setUnits(response?.data);
  };

  const handleUpdateUserAccess = async ({
    userId,
    rolesToAdd,
    rolesToRemove,
    permsToAdd,
    permsToRemove,
  }) => {
    showLoader();
    const promises = [];

    if (rolesToAdd.length > 0) {
      promises.push(
        httpPost(
          `${customBaseUrl.authUrl}/api/v1/admin/users/${selectedUser.id}/roles`,
          rolesToAdd,
        ),
      );
    }
    if (rolesToRemove.length > 0) {
      promises.push(
        httpDelete(
          `${customBaseUrl.authUrl}/api/v1/admin/users/${selectedUser.id}/roles`,
          rolesToRemove,
        ),
      );
    }
    if (permsToAdd.length > 0) {
      promises.push(
        httpPost(
          `${customBaseUrl.authUrl}/api/v1/admin/users/${selectedUser.id}/permissions`,
          permsToAdd,
        ),
      );
    }
    if (permsToRemove.length > 0) {
      promises.push(
        httpDelete(
          `${customBaseUrl.authUrl}/api/v1/admin/users/${selectedUser.id}/permissions`,
          permsToRemove,
        ),
      );
    }

    const results = await Promise.all(promises);
    hideLoader();

    const failed = results.find(
      (res) => !res || res.error !== undefined || res.status === false,
    );

    if (failed) {
      NotificationManager.error(
        failed.message || "Some changes could not be applied.",
        "Error",
      );
      return false;
    } else {
      Swal.fire(
        "Success",
        "User roles and permissions have been updated.",
        "success",
      );
      return true;
    }
  };

  const handleUpdateKYCLimit = async (TransLimit) => {
    showLoader();
    const data = {
      transactionLimit: TransLimit,
      userId: selectedUser,
    };
    const response = await httpPost(
      `/kyc-service/kyc/admin/upgradeTransLimit/${selectedUser}?transactionLimit=${TransLimit}`,
      customBaseUrl.authUrl,
    );
    if (response.status) {
      hideLoader();
      Swal.fire("Success", "Transaction Limit has been updated", "success");
      setShowUpdateKYC(false);
    } else {
      hideLoader();
      Swal.fire("Error", response.message, "error");
    }
  };

  const handleCreateAdmin = async (data) => {
    let domain = data.email.split("@");
    var numberRegex = /^\d+$/;
    //  const first3 = data?.phoneNumber.substring(0, 3);
    // if(first3 != '234') return NotificationManager.error('Not a valid phone number')
    // if(!numberRegex.test(data?.phoneNumber)) return NotificationManager.error('Not a valid waya phone number')

    // if(data?.phoneNumber.length !=13) return NotificationManager.error('Not a phone ')
    if (domain[1] !== "wayapaychat.com")
      return NotificationManager.error("Not a valid waya email address");
    showLoader();
    let res = await httpPost(
      `${customBaseUrl.authUrl}/api/v1/admin/users/create`,
      {
        ...data,
        phoneNumber: `+234${data?.phoneNumber.slice(-10)}`,
        roles: data.roles,
        permissions: data.permissions ? data.permissions.map((p) => p.name || p) : [],
      },
    );

    if (res.success === true) {
      hideLoader();
      setShowAdmin(false);
      Swal.fire("Done", res.message, "success");
      getAdminUsers();
    } else {
      hideLoader();
      Swal.fire("Something went wrong", res.message, "error");
    }
  };

  const deactivateAdmin = async (user) => {
    showLoader();
    const response = await httpDelete(
      `${customBaseUrl.authUrl}/api/v1/user/delete/${user.userId}`,
    );

    if (response.status) {
      hideLoader();
      getAdminUsers();
      Swal.fire("Deleted!", response.message, "success");
    } else {
      hideLoader();
      Swal.fire("Error", response.message);
    }
  };

  const handleSearch = async (searchBy, searchText) => {
    if (!searchText) {
      getAdminUsers();
      return;
    }
    showLoader();
    const payload = {
      userType: "ADMIN",
      [searchBy]: searchText,
      page: 0,
      size: pagination.pageSize,
    };
    if (dateRange) {
      payload.createdDateFrom = dateRange[0].format('YYYY-MM-DDT00:00:00');
      payload.createdDateTo = dateRange[1].format('YYYY-MM-DDT23:59:59');
    }
    if (status) {
      payload.status = status;
    }
    if (kycStatus) {
      payload.kycStatus = kycStatus;
    }
    const response = await httpPost(
      `${customBaseUrl.authUrl}/admin/users/search?`,
      payload,
    );
    hideLoader();
    if (response?.success) {
      const data = response?.data;
      setUsers(data?.users);
      setMetaData(data?.totalElements);
      setLinks(data?._links);
    } else if (response?.success === false) {
      Swal.fire(
        "No results",
        "No admin users found matching your search",
        "info",
      );
    } else {
      Swal.fire(
        "Error",
        "An error occurred while searching. Please try again.",
        "error",
      );
    }
  };

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("action") === "create") {
      setShowAdmin(true);
    }
  }, [location.search]);

  useEffect(() => {
    setUsers([]);
    getAdminUsers();
    getPendingCreations();
    getRoles();
    getPermissions();
    getUnits();
  }, []);

  const handleShowChangeRole = (userObject) => {
    let newUserObject = { ...userObject };
    newUserObject.isVisible = !showChangeRole.isVisible;
    setShowChangeRole(newUserObject);
  };

  const handleUpdateKYC = (userObject) => {
    let newUserObject = { ...userObject };
    newUserObject.isVisible = !showChangeRole.isVisible;
    setShowUpdateKYC(newUserObject);
  };

  return (
    <Layout>
      <Box>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          mb={4}
        >
          <PageHeader
            title="Admin Accounts Management"
            description="Search and manage bank administrators"
          />
          <PrimaryCreateButton onClick={() => setShowAdmin(true)}>
            Create New Admin User
          </PrimaryCreateButton>
        </Stack>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <SearchTypeSelector
              searchType={search.searchBy}
              handleSearchTypeChange={(event) => {
                setSearch({ ...search, searchBy: event.target.value });
              }}
              searchTypes={searchTypes}
            />
            <TextField
              fullWidth
              size="small"
              placeholder={placeholder}
              value={search.searchText}
              onChange={(e) =>
                setSearch({
                  ...search,
                  searchText: e.target.value,
                })
              }
              // onBlur={(e) => setSearchQ( ...search, searchText: e.target.value,)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon size={18} />
                  </InputAdornment>
                ),
              }}
            />

            <DatePicker.RangePicker 
              style={{ height: '40px' }}
              onChange={(dates) => setDateRange(dates)}
            />

            <AntSelect
              value={status}
              onChange={setStatus}
              placeholder="User Status"
              allowClear
              style={{ width: 140, height: '40px' }}
            >
              {userStatuses.map(s => <AntSelect.Option key={s.value} value={s.value}>{s.label}</AntSelect.Option>)}
            </AntSelect>

            <AntSelect
              value={kycStatus}
              onChange={setKycStatus}
              placeholder="KYC Status"
              allowClear
              style={{ width: 140, height: '40px' }}
            >
              {kycStatuses.map(s => <AntSelect.Option key={s.value} value={s.value}>{s.label}</AntSelect.Option>)}
            </AntSelect>

            <Button
              variant="contained"
              sx={{
                px: 5,
                fontWeight: 500,
              }}
              onClick={() => handleSearch(search.searchBy, search.searchText)}
            >
              Search
            </Button>
          </Box>
          <DecorateListTypes searchTypes={searchTypes} />
        </Box>
        <Box>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mb: 2, gap: 1 }}
          >
            <Button
              sx={{ color: "#000", fontSize: "10px" }}
              onClick={() => navigate("/admin/manage_roles")}
              icon={<SettingFilled className={styles.manageButtonIcon} />}
            >
              Manage Roles and Access
            </Button>
            <Button
              variant="outlined"
              sx={{
                borderColor: "#27AE60",
                color: "#27AE60",
                fontSize: "12px",
              }}
              onClick={async () => {
                showLoader();
                try {
                  const payload = {
                    userType: "ADMIN",
                    [search.searchBy]: search.searchText,
                    status,
                    kycStatus,
                  };
                  if (dateRange) {
                    payload.createdDateFrom = dateRange[0].format('YYYY-MM-DDT00:00:00');
                    payload.createdDateTo = dateRange[1].format('YYYY-MM-DDT23:59:59');
                  }
                  
                  const res = await httpPostBlob(`${customBaseUrl.authUrl}/admin/users/export`, payload);
                  if (res) {
                    const url = window.URL.createObjectURL(new Blob([res], { type: 'text/csv' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `Admin_Export_${moment().format('YYYYMMDD_HHmmss')}.csv`);
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                    NotificationManager.success("Export successful!");
                  } else {
                    NotificationManager.error("Export failed");
                  }
                } catch (e) {
                  NotificationManager.error("An error occurred during export");
                } finally {
                  hideLoader();
                }
              }}
            >
              Export
            </Button>
          </Box>

          <Tabs
            activeKey={activeTab}
            onChange={(key) => {
              setActiveTab(key);
              if (key === "3" && deletedUsers.length === 0) {
                getDeletedAdmins(0, deletedPagination.pageSize);
              }
            }}
            tabBarStyle={{ marginBottom: 20 }}
          >
            <TabPane tab="All Admins" key="1">
              <TableResultCount value={metaData} />
              <AntTable
                pagination={pagination}
                users={users}
                loading={loading}
                handleGetNext={handleChangePage}
                columns={AdminColumns(sekxhandleDropdownAction)}
              />
            </TabPane>

            <TabPane tab="Pending Requests" key="2">
              <TableResultCount value={pendingMetaData} />
              <AntTable
                pagination={pendingPagination}
                users={pendingRequests}
                loading={pendingLoading}
                handleGetNext={(e, page) => {
                  setPendingPagination({ ...pendingPagination, current: page });
                  getPendingCreations(page, pendingPagination.pageSize);
                }}
                columns={PendingAdminColumns({
                  reject: (id) => handleRejectRequest(id),
                  approve: (id) => handleApproveRequest(id),
                })}
              />
            </TabPane>

            <TabPane tab="Deleted Admins" key="3">
              <TableResultCount value={deletedMetaData} />
              <AntTable
                pagination={deletedPagination}
                users={deletedUsers}
                loading={deletedLoading}
                handleGetNext={({ pagination: info }) => {
                  setDeletedPagination(info);
                  getDeletedAdmins(info.current - 1, info.pageSize);
                }}
                columns={DeletedAdminColumns({
                  reactivate: (record) => setReactivateTarget(record),
                })}
              />
            </TabPane>
          </Tabs>
        </Box>

        {showChangeRole.isVisible ? (
          <ChangeRole
            showModal={showChangeRole}
            setShowModal={setShowChangeRole}
            roles={roles}
            permissions={permissions}
            handleUpdateUserAccess={handleUpdateUserAccess}
            getAdminUsers={getAdminUsers}
          />
        ) : (
          ""
        )}
        {showUpdateKYC.isVisible ? (
          <UpdateKYC
            showModal={showUpdateKYC}
            setShowModal={setShowUpdateKYC}
            roles={roles}
            handleUpdateKYCLimit={handleUpdateKYCLimit}
          />
        ) : (
          ""
        )}

        {showAdmin ? (
          <NewAdminUser
            showModal={showAdmin}
            setShowModal={setShowAdmin}
            data={data}
            setData={setData}
            handleSubmit={handleCreateAdmin}
            roles={roles}
            units={units}
          />
        ) : null}
        {showExport ? (
          <ExportData
            showModal={showExport}
            hideModal={setShowExport}
            dataList={users}
          />
        ) : null}

        {reactivateTarget ? (
          <ReactivateAdmin
            showModal={Boolean(reactivateTarget)}
            setShowModal={() => setReactivateTarget(null)}
            user={reactivateTarget}
            roles={roles}
            permissions={permissions}
            onSubmit={handleReactivateAdmin}
            submitting={reactivateSubmitting}
          />
        ) : null}
      </Box>
    </Layout>
  );
}
